<script lang="ts">
export default {
  name: 'LayoutPage'
};
</script>
<script lang="ts" setup>
import ImpersonateFrame from '#components/layouts/ImpersonateFrame/ImpersonateFrame.vue';
import SideBar from '#components/sideBar/SideBar.vue';
import { useImpersonateToken } from '#domain/core/admin/composables/useImpersonateToken';
import { useUserStore } from '#stores/user.store';
import { useStorage } from '@vueuse/core';
import { computed } from 'vue';

defineProps({
  isProjectsAdmin: { type: Boolean, default: false }
});

const userStore = useUserStore();

const isSidebarOpenStorage = useStorage('sidebarOpen', false);
const impersonateTokenStorage = useImpersonateToken();

function handleToggle() {
  isSidebarOpenStorage.value = !isSidebarOpenStorage.value;
}

const clx = computed(() => ({
  'ml-sidebar-width': isSidebarOpenStorage.value,
  'ml-sidebar-close': !isSidebarOpenStorage.value,
  'overflow-x-hidden': userStore.isImpersonating
}));

const topPaddingImpersonation = computed(() => ({
  'pt-impersonation-height': userStore.isImpersonating
}));

function stopImpersonate() {
  impersonateTokenStorage.value = null;
  window.location.href = window.location.origin + window.location.pathname;
}
</script>

<template>
  <div>
    <div class="fixed">
      <SideBar
        :is-open="isSidebarOpenStorage"
        :is-admin="userStore.isAdmin"
        :is-account-manager="userStore.isAccountManager"
        :is-projects-authorized="userStore.isProjectsAuthorized"
        :is-projects-admin="isProjectsAdmin"
        :is-innovations-authorized="userStore.isInnovationsAuthorized"
        :is-impersonating="userStore.isImpersonating"
        :is-organization-creator="userStore.isOrganizationsCreator"
        @toggle="handleToggle"
      />
    </div>
    <main class="bg-white h-screen relative mx-3" :class="clx">
      <ImpersonateFrame
        v-if="userStore.isImpersonating"
        :sidebar-state="isSidebarOpenStorage ? 'open' : 'collapsed'"
        @stop-impersonate="stopImpersonate"
      />
      <div :class="topPaddingImpersonation">
        <div class="w-full relative">
          <slot name="header" />
          <section class="container isolate mx-auto">
            <div class="container py-2 flex flex-col px-8">
              <slot name="header-content" />
            </div>
          </section>
        </div>

        <div class="container isolate mx-auto">
          <div class="container py-2 flex flex-col px-8">
            <slot />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
